
const swiperTc = new Swiper(".swiper-testimonials-carousel", {   
   loop: true,
   slidesPerView: 1,
   autoplay: {
      delay: 2500,
      disableOnInteraction: false,
   },
   navigation: {
      nextEl: "#testimonials-carousel-next",
      prevEl: "#testimonials-carousel-prev",
   },
   pagination: {
      clickable: true,
      el: "#testimonials-carousel-pagination",
   }
});

